import api from './axiosConfig';
import { PLANT_ENDPOINT } from './apiEndpoints';
import { logError } from './errorLogService';

const mockData = [
    {
        id: 1,
        name: "Weifang Manufacturing Base (West Plant)",
        link_location: "https://maps.app.goo.gl/DHBwxoFc8V5JU7Vs8",
        image_src: "/assets/images/company/1- Weifang Manufacturing Base.webp",
    },
    {
        id: 2,
        name: "Weifang Manufacturing Base (North Plant)",
        link_location: "https://maps.app.goo.gl/LU211CcwcGP7qWX27",
        image_src: "/assets/images/company/2- Weifang Manufacturing Base.webp",
    },
    {
        id: 3,
        name: "Weifang Manufacturing Base (East Plant)",
        link_location: "https://maps.app.goo.gl/CpcuBh3uPgZVL3oD6",
        image_src: "/assets/images/company/3- Weifang Manufacturing Base.webp",
    },
    {
        id: 4,
        name: "Ningxia Manufacturing Base (North Plant)",
        link_location: "https://maps.app.goo.gl/Ha2QbLexuokwnxQW8",
        image_src: "/assets/images/company/4- Ningxia Production Base.webp",
    },
    {
        id: 5,
        name: "Ningxia Manufacturing Base (South  Plant)",
        link_location: "https://maps.app.goo.gl/r99NLBJ9xpDYZwRv9",
        image_src: "/assets/images/company/5- Ningxia Production Base.webp",
    },
    {
        id: 6,
        name: "Qingdao Manufacturing Base",
        link_location: "https://maps.app.goo.gl/UGRszp7hm1K4eunF8",
        image_src: "/assets/images/company/6- Qingdao Manufacturing Base.webp",
    },
    {
        id: 7,
        name: "Spain Manufacturing Base",
        link_location: "https://maps.app.goo.gl/VCSqNqTGK9QJPMPM7",
        image_src: "/assets/images/company/7- Spain Manufacturing Base.webp",
    },
    {
        id: 8,
        name: "US Manufacturing Base",
        link_location: "https://maps.app.goo.gl/A798ArZ15uUSt9cm6",
        image_src: "/assets/images/company/8- Houston Manufacturing Base.webp",
    },
    {
        id: 9,
        name: "Argentina Manufacturing Base",
        link_location: "https://maps.app.goo.gl/Z1j6doV3tHY2iRsv5",
        image_src: "/assets/images/company/9. Argentina Manufacturing Base.webp",
    },
    {
        id: 10,
        name: "Jinan R&D Center",
        link_location: "https://maps.app.goo.gl/djtR5UsJ5AzC1jYF8",
        image_src: "/assets/images/company/10- Jinan R & D Center.webp",
    },
    {
        id: 12,
        name: "Weifang R&D Center",
        link_location: "https://maps.app.goo.gl/DHBwxoFc8V5JU7Vs8",
        image_src: "/assets/images/company/12- Weifang R&D Center.webp",
    },
    {
        id: 11,
        name: "Weifang Process development center",
        link_location: "https://maps.app.goo.gl/DHBwxoFc8V5JU7Vs8",
        image_src: "/assets/images/company/Weifang Process development center.webp",
    },
];

export const fetchPlant = async () => {
    // return mockTeamData;

    try {
        const response = await api.get(PLANT_ENDPOINT());
        return response.data;
    } catch (error) {
        console.error("Error fetching hero data", error);

        await logError('plant_data_fetch', error, {
            endpoint: PLANT_ENDPOINT(),
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        return mockData;
    }
};
